// Notification banner js

(function ($) {
  const $notification_banner = $(".notification-banner");
  const $notification_banner_content = $.trim(
    $notification_banner.find(".notification-banner--content").html(),
  );
  const $notification_accept_button = $notification_banner.find(
    ".notification-banner--button",
  );
  const $notification_close_button = $notification_banner.find(
    ".notification-banner--close",
  );
  const $daysToLive = Number($notification_banner.attr("data-max-age"));
  let cookie_hash = $notification_banner_content;

  // cookie settings
  const cookieName =
      "hoas-notification-banner-" + window.generateHash(cookie_hash),
    cookieValue = "read_" + window.generateHash(cookie_hash);
  let daysToLive = $daysToLive;

  // Old cookie
  const old_cookie = window.getCookie(cookieName);

  // If old cookie exists, and cookieName+hash matches, hide. Otherwise something has changed, and it needs to be read
  if (old_cookie && old_cookie === cookieValue) {
    //$notification_banner.hide(0);
    return;
  }

  // Show the notification if no cookie was found
  $notification_banner.removeClass("hidden");

  // Close function
  function closeModal(evt) {
    evt.preventDefault();
    // Animate off
    $notification_banner.animate(
      {
        opacity: 0,
        height: 0,
      },
      300,
      function () {
        $(this).remove();
      },
    );

    // Set cookie lifetime to a minimum of 1 day, since the session does not work as expected in modern browsers
    if (isNaN(daysToLive)) {
      daysToLive = 1;
    }
    // Set/update cookie
    window.setCookie(cookieName, cookieValue, daysToLive);
  }

  //-- If banner exists add a close btn event
  if ($notification_banner.length) {
    //-- Ok btn click event
    $notification_accept_button.on("click", function (evt) {
      closeModal(evt);
    });

    $notification_close_button.on("click", function (evt) {
      closeModal(evt);
    });
  }
})(window.jQuery);
